<template>
  <client-only>
    <footer>
      <div class="container">
        <div class="copyright">
          {{
            $t("footer.bottom.company_copyright", {
              year: new Date().getFullYear(),
            })
          }}
        </div>
        <div class="copyright">
          <router-link class="support-link item" :to="{ name: 'support' }">
            {{ $t("zammad_support.link") }}
          </router-link>
          |
          <router-link class="item" :to="{ name: 'faqs' }">
            {{ $t("header.faqs") }}
          </router-link>
          |
          <a :href="termsUrl" target="_blank">
            {{ $t("footer.items.legals.terms") }}
          </a>
          |
          <a :href="privacyUrl" target="_blank">
            {{ $t("footer.items.legals.privacy") }}
          </a>
          |
          <a :href="'mailto:soporte@divasplay.com'" target="_blank">
            {{ $t("footer.items.legals.complaints") }}
          </a>
        </div>
      </div>
    </footer>
  </client-only>
</template>

<script setup lang="ts">
const { $i18n } = useNuxtApp();

const privacyUrl = computed(() => {
  let langCode = $i18n.locale.value;
  return `/legals/privacy/${langCode}.pdf`;
});

const termsUrl = computed(() => {
  let langCode = $i18n.locale.value;
  return `/legals/terms/${langCode}.pdf`;
});

const complianceUrl = computed(() => {
  let langCode = $i18n.locale.value;
  return `/legals/compliance/${langCode}.html`;
});
</script>

<style scoped lang="scss">
footer {
  padding: 20px;
  text-align: center;
  display: flex;
  color: #a8a8a8;

  a {
    font-weight: bold;
    text-decoration: underline;
  }

  @media (max-width: 960px) {
    flex-direction: column;
  }

  .copyright {
    @media (max-width: 960px) {
      text-align: center;
    }
  }
}
</style>
